import COLORS from 'COLORS'

export const structure = {
  city: null,
  map: {},
  activeRoutesId: [],
  activeGroupsId: [],
  currentRoute: null,
  currentRoutes: [],
  currentPointCoordinates: [],
  routeColor: COLORS.mapColors.default,
  fields: {},
  accidentFields: {},
  filters: {
    stops: [],
    vehicles: []
  },
  objectCard: null,
  routeId: null,
  routeStopsIds: null,
  vehicleTypes: null,
  layerNames: {},
  reportConfigs: {}
}

export const nonClearableFields = ['city', 'map']
